var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRichText = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M11.424 10.284L9.14396 4.668C9.09596 4.572 8.99996 4.5 8.87996 4.5H7.15196C7.05596 4.5 6.93596 4.572 6.91196 4.668L4.79996 10.284C4.77596 10.38 4.82396 10.524 4.96796 10.524H6.07196C6.16796 10.524 6.28796 10.428 6.31196 10.332L6.74396 9.132H9.40796L9.88796 10.332C9.91196 10.428 10.032 10.524 10.128 10.524H11.232C11.376 10.524 11.448 10.404 11.424 10.284ZM7.24796 7.692L7.94396 5.916H8.08796L8.85596 7.692H7.24796Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M4.5 13.5C4.5 13.0858 4.83579 12.75 5.25 12.75H18.75C19.1642 12.75 19.5 13.0858 19.5 13.5C19.5 13.9142 19.1642 14.25 18.75 14.25H5.25C4.83579 14.25 4.5 13.9142 4.5 13.5Z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M13.5 9.75C13.5 9.33579 13.8358 9 14.25 9H18.75C19.1642 9 19.5 9.33579 19.5 9.75C19.5 10.1642 19.1642 10.5 18.75 10.5H14.25C13.8358 10.5 13.5 10.1642 13.5 9.75Z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M4.5 18C4.5 17.5858 4.83579 17.25 5.25 17.25H18.75C19.1642 17.25 19.5 17.5858 19.5 18C19.5 18.4142 19.1642 18.75 18.75 18.75H5.25C4.83579 18.75 4.5 18.4142 4.5 18Z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgRichText);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/rich-text.8f742c238ced4f79ff2bd490d716cadc.svg";